import React, { Component } from 'react';

class S4CClicButton extends Component {
  render() {
    const { logoColour, orangeColour } = this.props;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
        <defs>
          <path
            id="logoC"
            d="M450.15,364.85,363,320.19a119.6,119.6,0,1,1-2-142.9l87.87-44A216.94,216.94,0,0,0,272,33.29h-.55c-1.49,0-3-.06-4.46-.06h-.38C147.1,33.22,49.85,130.46,49.85,250S147.1,466.78,266.63,466.78a215.55,215.55,0,0,0,91-20l.75-.35c.82-.38,1.62-.77,2.43-1.16,1.29-.63,2.58-1.27,3.86-1.92l.32-.17A218.45,218.45,0,0,0,450.15,364.85Z"
          />
          <mask id="logoPath1Mask">
            <path
              id="logoPath1"
              d="M413,166.8A168.71,168.71,0,0,0,266.46,81.49C174,81.49,97.94,157.56,97.94,250S174,418.51,266.46,418.51A168.67,168.67,0,0,0,411,336.56"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="114"
              ref={(path) => {
                this.logoPath1 = path;
              }}
            />
          </mask>
        </defs>
        <g>
          <g className="logoCGroup1" mask="url(#logoPath1Mask)">
            <use xlinkHref="#logoC" fill={logoColour} />
          </g>
          <polygon
            className="playIcon"
            points="233.62 172.38 233.62 325.51 335.93 249.11 233.62 172.38"
            fill={orangeColour}
          />
        </g>
      </svg>
    );
  }
}

class PlayerPlayButton extends Component {
  render() {
    return (
      <S4CClicButton
        logoColour={'rgba(255, 255, 255, 0.35)'}
        orangeColour={'#f8a51b'}
      />
    );
  }
}

export default PlayerPlayButton;
